export const formatPhoneNumber = (value) => {
  let formattedValue = value.replace(/\D/g, '');

  if (formattedValue.length > 8) {
    formattedValue = formattedValue.slice(0, 8);
  }

  let phoneNumber = '';
  for (let i = 0; i < formattedValue.length; i++) {
    phoneNumber += formattedValue[i];
    if ((i + 1) % 2 === 0 && i !== formattedValue.length - 1) {
      phoneNumber += '-';
    }
  }

  return phoneNumber;
};

export const fromLocalPhone = (phone) =>
  phone.length === 12 &&
  phone
    .slice(4, phone.length)
    .split('')
    .map((char, index) => {
      if (index % 2 !== 0 && index !== 7) {
        return `${char}-`;
      }

      return char;
    })
    .join('');
